/**
 * One-shot hand-off from the print layout to the Report Builder (Wave 5.4).
 *
 * "Send to Report Builder" stores the composed page (a PNG data URL plus its page size) here;
 * ReportBuilder reads it once on mount and starts with that page as a full-bleed `map`
 * element, the same element type its own "Map Snapshot" button adds (a data URL in `src`).
 * In-memory only (like lib/model-store.js): the image can be large.
 */
let pending = null;

export function setReportHandoff(handoff) { pending = handoff || null; }
export function peekReportHandoff() { return pending; }
export function clearReportHandoff() { pending = null; }

/**
 * Initial ReportBuilder state for a hand-off, or null.
 * @param mm px per mm used by the builder's page (ReportBuilder's MM constant)
 */
export function handoffToReportState(handoff, { mm, pageSizes, nextId }) {
  if (!handoff?.dataUrl) return null;
  const size = pageSizes[handoff.pageSize] ? handoff.pageSize : 'a4';
  const landscape = handoff.orientation !== 'portrait';
  const s = pageSizes[size];
  const w = (landscape ? s.h : s.w) * mm;
  const h = (landscape ? s.w : s.h) * mm;
  return {
    pageSize: size,
    landscape,
    elements: [{ id: nextId(), type: 'map', x: 0, y: 0, w, h, src: handoff.dataUrl }],
  };
}
